import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateWithFallback',
})
export class DateWithFallbackPipe implements PipeTransform {
  private readonly formatter = new Intl.DateTimeFormat('nb-NO', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  transform(date: Date | null | undefined, fallback = 'Ukjent') {
    if (!date) {
      return fallback;
    }

    return this.formatter
      .formatToParts(date)
      .map(({ type, value }) => {
        if (type === 'hour') {
          return `kl. ${value}`;
        }

        return value;
      })
      .join('');
  }
}
